/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />

module Meevo.Components.Controls {
  "use strict";

  export class MeevoPendingIndicator implements angular.IDirective {
    restrict = "E";
    scope = {
      name: "@",
      contentKey: "@"
    };

    require = "^form";

    link = (scope: any, element: angular.IAugmentedJQuery, attrs: angular.IAttributes, formCtrl: any) => {
      let html = "";
      if (formCtrl != null) {

        /* Build path for ngMessages */
        let root = "scope.";
        let prefix = "$parent.";
        let suffix = formCtrl.$name;

        while (eval(root + prefix + suffix) === undefined) {
          prefix = prefix + "$parent.";
        }

        let path = prefix + formCtrl.$name + "." + scope.name;
        html += "<div ng-show='" + path + ".$pending\'><span translate='{{::contentKey}}' /></div>";

        element.append(html);
        this.$compile(element.contents())(scope);
      }
    }


    constructor(private $compile: angular.ICompileService) {

    }

    static factory(): angular.IDirectiveFactory {
      let directive = ($compile) => {
        return new MeevoPendingIndicator($compile);
      };

      directive.$inject = ["$compile"];
      return directive;
    }
  }

  angular.module("meevo.components.controls")
    .directive("meevoPendingIndicator", MeevoPendingIndicator.factory());

}